import { getAccuracyLogoUrl } from 'helpers/accuracy_logo';

const AccuracyLogo: any = (props) => {
    const container = document.createElement('div');
    const logo = document.createElement('img');

    logo.setAttribute('src', getAccuracyLogoUrl(props.value));
    //logo.setAttribute('alt', props.value);

    logo.style.height = '80%';

    container.classList.add('h-full', 'flex', 'items-center');
    //container.setAttribute('title', props.value);

    container.appendChild(logo);

    return container;
};

export default AccuracyLogo;
